import {
  NavigationGuardNext,
  RouteRecordRaw,
} from 'vue-router';

import {
  useEditShopSplitPaymentStore,
  useEditShopStore,
  useRootStore,
  useSystemSettingStore,
} from '@/store';

const validateSplitUse = (next: NavigationGuardNext) => {
  const splitUseFlg = useSystemSettingStore().systemSetting?.splitUseFlg;
  if (!splitUseFlg) {
    next({ name: 'NotFound' });
  }
};

// 店舗関連
export const shopRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Shop',
    component: () => import('@/components/pages/shop/index.vue'),
    path: '/shop',
    meta: {
      title: '店舗',
      requiredAuthority: 'SHOPS',
    },
  },
  {
    name: 'ShopId',
    component: () => import('@/components/pages/shop/detail/index.vue'),
    path: '/shop/:id',
    meta: {
      title: '店舗詳細',
      requiredAuthority: 'SHOPS',
    },
  },
  {
    name: 'ShopEdit',
    component: () => import('@/components/pages/shop/detail/edit/index.vue'),
    path: '/shop/:id/edit',
    meta: {
      title: '店舗編集',
      requiredAuthority: 'EDIT_SHOPS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const editShopStore = useEditShopStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'ShopDetailEditConfirm') {
        await editShopStore.setInitData(id);
        editShopStore.$resetForm();
        useRootStore().$reset();
      }
      next();
    },
  },
  {
    name: 'ShopDetailEditConfirm',
    component: () => import('@/components/pages/shop/detail/edit/confirm/index.vue'),
    path: '/shop/:id/edit/confirm',
    meta: {
      title: '店舗編集確認',
      requiredAuthority: 'EDIT_SHOPS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditShopStore();
      const {
        form,
        initData,
      } = store;

      if (from.path === `/shop/${id}/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/shop/${id}`, replace: true });
      }
    },
  },
  {
    name: 'ShopSplitPayment',
    component: () => import('@/components/pages/shop/detail/shop-split-payment/index.vue'),
    path: '/shop/:id/split-payment',
    meta: {
      title: '分割決済情報',
      requiredAuthority: 'SHOPS',
    },
    beforeEnter: async (to, _, next) => {
      validateSplitUse(next);

      // storeに詳細APIの結果をセットする
      const id = to.params.id.toString();
      const store = useEditShopSplitPaymentStore();
      await store.setInitData(id);

      next();
    },
  },
  {
    name: 'ShopSplitPaymentEdit',
    component: () => import('@/components/pages/shop/detail/shop-split-payment/edit/index.vue'),
    path: '/shop/:id/split-payment/edit',
    meta: {
      title: '分割決済情報編集',
      requiredAuthority: 'EDIT_SHOPS',
    },
    beforeEnter: async (to, from, next) => {
      validateSplitUse(next);
      const id = to.params.id.toString();
      const store = useEditShopSplitPaymentStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'ShopSplitPaymentEditConfirm') {
        await store.setInitData(id);
        store.$resetForm();
        useRootStore().$reset();
      }
      next();
    },
  },
  {
    name: 'ShopSplitPaymentEditConfirm',
    component: () => import('@/components/pages/shop/detail/shop-split-payment/edit/confirm/index.vue'),
    path: '/shop/:id/split-payment/edit/confirm',
    meta: {
      title: '分割決済情報編集確認',
      requiredAuthority: 'EDIT_SHOPS',
    },
    beforeEnter: async (to, from, next) => {
      validateSplitUse(next);
      const id = to.params.id.toString();
      const store = useEditShopSplitPaymentStore();
      const {
        form,
        initData,
      } = store;

      if (from.path === `/shop/${id}/split-payment/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/shop/${id}/split-payment`, replace: true });
      }
    },
  },
];
